import { useId } from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import type { TooltipProps } from './types';

export function Tooltip(props: TooltipProps) {
  const id = useId();

  return (
    <span data-tooltip-id={id} className="inline-flex">
      <ReactTooltip
        id={id}
        className="whitespace-normal! z-60! max-w-85! rounded-lg! bg-white! p-0.5! font-normal! text-sm! text-spark-text-primary! shadow-md! transition-opacity! duration-200!"
        opacity={1}
        border="1px solid #d1d5db"
        clickable
        delayHide={200}
      >
        {props.content}
      </ReactTooltip>
      {props.children}
    </span>
  );
}
